<template>
  <div>
    <v-sheet class="transparent-background-color">
      <div class="px-4 pt-4">
        <v-card class="px-4 pb-4">
          <v-card-title class="mx-3">
            {{ $t("Shop.import.title", [$consts.shopName()]) }}
            <v-spacer />
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="$emit('close')">
                  fa-times
                </v-icon>
              </template>
              <span>{{ $t("Shop.import.close", [$consts.shopName()]) }}</span>
            </v-tooltip>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="Headers"
            :items="value"
            multi-sort
            disable-pagination
            hide-default-footer
            class="pb-2"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n3">
                  <span class="Body 2 secondary--text pt-2">
                    <span class="red--text">
                      {{ $t("Shop.import.hint", [$consts.shopName()]) }}
                    </span>
                  </span>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:item.error_msg="{ item }">
              <span class="red--text">
                {{ item.error_msg }}
              </span>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";

export default {
  props: ["value"],
  computed: {
    Headers() {
      return [
        {
          text: i18n.t("Shop.Fields.shop_code", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_code",
        },
        {
          text: i18n.t("Shop.Fields.shop_name", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_name",
        },
        {
          text: i18n.t("Shop.import.district_number"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "district_number",
        },
        {
          text: i18n.t("Shop.import.address"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "address",
        },
        {
          text: i18n.t("Shop.Fields.template"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "material_template",
        },
        {
          text: i18n.t("Shop.Fields.shop_user_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_user_name",
        },
        {
          text: i18n.t("Shop.import.tel"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "tel",
        },
        {
          text: i18n.t("Shop.import.login_user_id"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "login_user_id",
        },
        {
          text: i18n.t("Shop.import.error_msg"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "error_msg",
        },
      ];
    },
  },
};
</script>
